import React, { useState, useEffect, useRef } from "react";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EmailIcon from "@mui/icons-material/Email";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import GetAppIcon from "@material-ui/icons/GetApp";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import HistoryIcon from "@mui/icons-material/History";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Person as PersonIcon,
  AttachFile as AttachFileIconMui,
  Info as InfoIcon,
  Business as BusinessIcon,
  Description as DescriptionIcon,
  Receipt as ReceiptIcon,
  SnippetFolder as SnippetFolderIcon,
  LocalOffer as LocalOfferIcon,
  Rule as RuleIcon,
  Sync as SyncIcon,
  FactCheck as FactCheckIcon,
  Verified as VerifiedIcon,
  PublishedWithChanges as PublishedWithChangesIcon,
} from "@mui/icons-material";
import { formatDate, getRequest, postRequest } from "../../globalhelper/helper";
import VR2_Forms from "../../pages/VR2_Form_Rendering/displayContainer";
import "../CI/COD.css";
import globalhelper from "../../helper/globalhelper";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Grid,
  Select,
  MenuItem,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Tooltip,
  Dialog,
  DialogContent,
  useTheme,
  Alert,
  AlertTitle,
  Pagination,
  Drawer,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Divider,
} from "@mui/material";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import { useDispatch } from "react-redux";
import { hideLoader } from "../../redux/Common/commonActions";
import { CSVLink } from "react-csv";
import { DialogBox } from "../../components/DialogBox/DialogBox";

const FetchEmail = ({
  orgid,
  companyName,
  resultArray,
  showSearchScreen,
  handleSubmit,
}) => {
  const [state, setState] = useState({
    clickedRow: [],
    sourceData: [],
    emails: [],
    filename: "",
    fileData: "",
    data: [],
    resetData: [],
    currentPage: 1,
    postsPerPage: 20,
    tableDisplay: [],
    filterTable: [],
    readMoreItem: [],
    currentPage1: 1,
    postsPerPage1: 20,
    show_pdf: false,
    formData: {
      FromDate: "",
      ToDate: "",
      Date: "",
      From: "",
      Subject: "",
      Attachment: "",
      Status: "",
      VendorName: "",
      InvoiceRef: "",
      InvoiceDate: "",
      BillNumber: "",
      DocumentNumber: "",
      Tag: "",
      transactionstatus: "",
      UploadMode: "",
      description: "",
      integrationStatus: "",
    },
    attachment_data: "",
    fileType: "",
    selectedItem: null,
    pdfDescription: "",
    dropdown_date: [],
    dropdown_from: [],
    dropdown_subject: [],
    dropdown_attachment: [],
    dropdown_status: [],
    dropdown_vendorname: [],
    dropdown_invoicenumber: [],
    dropdown_invoicedate: [],
    dropdown_billnumber: [],
    dropdown_documentnumber: [],
    dropdown_tag: [],
    dropdown_documentstatus: [],
    dropdown_UploadMode: [],
    dropdown_integrationStatus: [],
    page: 0,
    rowsPerPage: 10,
    redirectBill: false,
    SearchJSON: [],
    updatedArray: [],
    fileUrl: null,
    auditLogs: {},
    auditLogModalOpen: false,
    isDrawerOpen: false,
    drawerItem: null,
  });

  const dispatch = useDispatch();
  const downloadLink = useRef(null);

  const handleChangePage = (event, newPage) => {
    setState((prev) => ({ ...prev, page: newPage }));
  };

  const getFilteredArray = (value, key) => {
    let dropdown_array = value?.map((value) => value[key]) || [];
    let filtered_dropdown_array = [...new Set(dropdown_array)];
    if (filtered_dropdown_array?.length) {
      return filtered_dropdown_array?.filter(
        (item) => item !== undefined && item !== "",
      );
    }
  };

  const handleReadMore = (index) => {
    if (state.readMoreItem.includes(index)) {
      let updated = state.readMoreItem.filter((ind) => ind !== index);
      setState((prev) => ({ ...prev, readMoreItem: updated }));
    } else {
      setState((prev) => ({
        ...prev,
        readMoreItem: [...prev.readMoreItem, index],
      }));
    }
  };

  const getAuditLogs = async (docNo) => {
    try {
      const value = await getRequest(
        `api/edureka/getDocAuditLog?orgid=${orgid}&DocNo=${docNo}`
      );
      setState((prev) => ({ ...prev, auditLogs: value?.res?.data || {}, auditLogModalOpen: true }));
    }
    catch (error) {
      console.log(error);
    }
  }

  const handleCloseAuditLog = () => {
    setState((prev) => ({ ...prev, auditLogModalOpen: false }));
  }

  useEffect(() => {
    const fetchData = async () => {
      const interimNumbers = getFilteredArray(resultArray, "BillNumber");
      const request = {
        orgid,
        interimNumbers,
      };

      try {
        const value = await postRequest(
          `api/edureka/getBillTransactionStatus`,
          request,
        );
        let arr1 = resultArray;
        let arr2 = value.res.data;
        const integrationStatus = {
          integrationStatus: "Nil",
        };

        const combinedArray =
          arr1?.map((item) => {
            console.log(arr2);

            if (arr2?.length) {
              const matched = arr2.find(
                (val) => val.BillNumber === item.BillNumber,
              );
              if (matched) {
                return { ...item, ...integrationStatus, ...matched };
              } else {
                return { ...item, ...integrationStatus };
              }
            } else {
              return { ...item };
            }
          }) || [];

        let filtered_dropdown_date = getFilteredArray(arr1, "Date");
        let filtered_dropdown_from = getFilteredArray(arr1, "From");
        let filtered_dropdown_subject = getFilteredArray(arr1, "Subject");
        let filtered_dropdown_attachment = getFilteredArray(arr1, "Attachment");
        let filtered_dropdown_status = getFilteredArray(arr1, "Status");
        let filtered_dropdown_vendorname = getFilteredArray(arr1, "VendorName");
        let filtered_dropdown_invoicenumber = getFilteredArray(
          arr1,
          "InvoiceRef",
        );
        let filtered_dropdown_invoicedate = getFilteredArray(
          arr1,
          "InvoiceDate",
        );
        let filtered_dropdown_billnumber = getFilteredArray(arr1, "BillNumber");
        let filtered_dropdown_documentnumber = getFilteredArray(
          arr2,
          "DocumentNumber",
        );
        let filtered_dropdown_tag = getFilteredArray(arr1, "Tag");
        let filtered_dropdown_documentstatus = getFilteredArray(
          arr2,
          "transactionstatus",
        );
        let filtered_dropdown_integrationstatus = getFilteredArray(
          arr2,
          "integrationStatus",
        );
        let filtered_dropdown_UploadMode = getFilteredArray(arr1, "UploadMode");

        setState((prev) => ({
          ...prev,
          sourceData: combinedArray,
          filterTable: combinedArray,
          emails: combinedArray,
          resetData: combinedArray,
          dropdown_date: filtered_dropdown_date,
          dropdown_from: filtered_dropdown_from,
          dropdown_subject: filtered_dropdown_subject,
          dropdown_attachment: filtered_dropdown_attachment,
          dropdown_status: filtered_dropdown_status,
          dropdown_vendorname: filtered_dropdown_vendorname,
          dropdown_invoicenumber: filtered_dropdown_invoicenumber,
          dropdown_invoicedate: filtered_dropdown_invoicedate,
          dropdown_billnumber: filtered_dropdown_billnumber,
          dropdown_documentnumber: filtered_dropdown_documentnumber,
          dropdown_tag: filtered_dropdown_tag,
          dropdown_documentstatus: filtered_dropdown_documentstatus,
          dropdown_UploadMode: filtered_dropdown_UploadMode,
          dropdown_integrationStatus:
            filtered_dropdown_integrationstatus &&
              filtered_dropdown_integrationstatus?.length
              ? [...filtered_dropdown_integrationstatus, "Not Initiated"]
              : ["Not Initiated"],
        }));
      } catch (err) {
        console.log(err);
      } finally {
        dispatch(hideLoader());
      }
    };

    fetchData();
  }, [orgid, resultArray, dispatch]);

  const downloadAttachment = async (data, fileName) => {
    try {
      const blob = new Blob([Buffer.from(data)], { type: data.type });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDocument = (item) => {
    localStorage.setItem(
      'selectedItem',
      JSON.stringify(item)
    )
    localStorage.setItem(
      'OrgName',
      companyName
    )
    localStorage.setItem(
      'api',
      `api/edureka/getUpdatedDataFromDB`
    )
    localStorage.setItem('apiParams', JSON.stringify({
      "LDE": {
        "Organization ID": orgid,
        "Bill Number": item.DocumentNumber,
      },
      "Module": localStorage.getItem('module'),
      "screenName": "BillExtract"
    }))
    window.open(
      `/Dynamic_Forms?token=BillExtract&action=edit&orgId=${orgid}&docId=${item.DocumentNumber}`,
      "_blank",
    );
    // getRequest(
    //   `api/edureka/getBillJSON?key=${item.DocumentNumber}&orgid=${orgid}`
    // ).then(response => {
    //   showSearchScreen(false)
    //   setState(prev => ({
    //     ...prev,
    //     redirectBill: true,
    //     SearchJSON: response.res.data
    //   }))
    // })
  };

  const handleBill = (item) => {
    localStorage.setItem(
      'selectedItem',
      JSON.stringify(item)
    )
    localStorage.setItem(
      'OrgName',
      companyName
    )
    localStorage.setItem(
      'api',
      `api/edureka/getUpdatedDataFromDB`
    )
    localStorage.setItem('apiParams', JSON.stringify({
      "LDE": {
        "Organization ID": orgid,
        "Bill Number": item.BillNumber,
      },
      "Module": localStorage.getItem('module'),
      "screenName": "BillExtract"
    }))
    window.open(
      `/Dynamic_Forms?token=BillExtract&action=edit&orgId=${orgid}&docId=${item.BillNumber}`,
      "_blank",
    );
    // getRequest(
    //   `api/edureka/getJSONViaKey?key=${item.BillNumber}&companyid=${orgid}`
    // ).then(response => {
    //   if (response.res.status === 'success') {
    //     showSearchScreen(false)
    //     setState(prev => ({
    //       ...prev,
    //       redirectBill: true,
    //       selectedItem: item,
    //       SearchJSON: response.res.data
    //     }))
    //   }
    // })
  };

  const handleS3Download = (item) => {
    const fileName = item.Attachment;
    const Date = item.CurrentDate;
    const UploadModeFE = item.UploadMode === "Manual Upload" ? true : false;
    const fileType = fileName.split(".").at(-1).toLowerCase();

    // Reset URL and show dialog immediately with loader
    setState((prev) => {
      if (prev.fileUrl) URL.revokeObjectURL(prev.fileUrl);
      return {
        ...prev,
        fileUrl: null,
        show_pdf: true,
        selectedItem: item,
        pdfDescription: item.description || "",
      };
    });

    postRequest(`api/edureka/getInboxPDF`, {
      file: fileName,
      date: Date,
      UploadModeFE: UploadModeFE,
      orgid: orgid,
    }).then((response) => {
      if (response && response.type === "success" && response.res.data) {
        const base64Data = response.res.data;
        const mimeType =
          fileType === "pdf"
            ? "application/pdf"
            : `image/${fileType === "jpg" ? "jpeg" : fileType}`;
        const blob = base64ToBlob(base64Data, mimeType);
        const url = URL.createObjectURL(blob);

        setState((prev) => ({
          ...prev,
          attachment_data: base64Data,
          fileUrl: url,
          fileType,
        }));
      }
    });
  };

  const base64ToBlob = (base64, mimeType) => {
    const byteArray = Uint8Array.from(atob(base64), (char) =>
      char.charCodeAt(0),
    );
    return new Blob([byteArray], { type: mimeType });
  };

  const handlePdfDescriptionChange = (e) => {
    setState((prev) => ({
      ...prev,
      pdfDescription: e.target.value,
    }));
  };

  const handlePdfDescriptionSave = () => {
    const array1 = state.emails;
    const array2 = state.tableDisplay;
    const array3 = state.filterTable;

    const objIndex1 = array1.findIndex(
      (obj) => obj.SK === state.selectedItem.SK,
    );
    const objIndex2 = array2.findIndex(
      (obj) => obj.SK === state.selectedItem.SK,
    );
    const objIndex3 = array3.findIndex(
      (obj) => obj.SK === state.selectedItem.SK,
    );

    if (state.pdfDescription) {
      const update11 =
        [array1[objIndex1]]?.map((obj) => {
          if (obj.transactionstatus === undefined) {
            const { transactionstatus, ...rest } = obj;
            return rest;
          } else {
            return obj;
          }
        }) || [];

      if (objIndex2 !== -1) {
        const update12 =
          [array2[objIndex2]]?.map((obj) => {
            if (obj.transactionstatus === undefined) {
              const { transactionstatus, ...rest } = obj;
              return rest;
            } else {
              return obj;
            }
          }) || [];

        let update2 = {
          ...update12[0],
          description: state.pdfDescription,
        };

        let updatedArray2 = [
          ...array2.slice(0, objIndex2),
          update2,
          ...array2.slice(objIndex2 + 1),
        ];
      }

      if (objIndex3 !== -1) {
        const update13 =
          [array3[objIndex3]]?.map((obj) => {
            if (obj.transactionstatus === undefined) {
              const { transactionstatus, ...rest } = obj;
              return rest;
            } else {
              return obj;
            }
          }) || [];

        let update3 = {
          ...update13[0],
          description: state.pdfDescription,
        };

        let updatedArray3 = [
          ...array3.slice(0, objIndex3),
          update3,
          ...array3.slice(objIndex3 + 1),
        ];

        setState((prev) => ({
          ...prev,
          updatedArray: updatedArray3,
        }));
      }

      const update1 = {
        ...update11[0],
        description: state.pdfDescription,
      };
      const updatedArray1 = [
        ...array1.slice(0, objIndex1),
        update1,
        ...array1.slice(objIndex1 + 1),
      ];
      console.log({ ...update1, showtextarea: false }, "update1");

      postRequest(`api/edureka/handleTagging`, {
        item: { ...update1, showtextarea: false },
      }).then((res) => {
        if (state.filterTable?.length) {
          setState((prev) => ({
            ...prev,
            emails: updatedArray1,
            resetData: updatedArray1,
            filterTable: prev.updatedArray,
          }));
        } else {
          setState((prev) => ({
            ...prev,
            emails: updatedArray1,
            resetData: updatedArray1,
          }));
        }
      });
    }
  };

  const handleEdit = (index) => {
    let updateddata = [...state.tableDisplay];
    updateddata[index] = {
      ...updateddata[index],
      showtextarea: !updateddata[index].showtextarea,
    };
    setState((prev) => ({
      ...prev,
      tableDisplay: updateddata,
    }));
  };

  const handleFilterTableEdit = (index, e) => {
    e.preventDefault();
    let updateddata = [...state.filterTable];
    updateddata[index] = {
      ...updateddata[index],
      showtextarea: !updateddata[index].showtextarea,
    };
    console.log(updateddata);

    setState((prev) => ({
      ...prev,
      filterTable: updateddata,
    }));
  };

  useEffect(() => {
    const myFunction = () => handleSubmit(true);
    console.log(
      resultArray.some(
        (item) =>
          item.Status === "Reprocessing" || item.Status === "Validating",
      ),
      state.redirectBill,
    );
    const intervalId = setInterval(() => {
      if (
        resultArray.some(
          (item) =>
            item.Status === "Reprocessing" || item.Status === "Validating",
        ) &&
        !state.redirectBill
      ) {
        myFunction();
      }
    }, 300000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    console.log(state.clickedRow.length, state.redirectBill);

    const myFunction = () => handleSubmit(true);

    const intervalId = setInterval(() => {
      if (state.clickedRow.length < 0 && !state.redirectBill) {
        myFunction();
      }
    }, 300000);

    return () => clearInterval(intervalId);
  }, [state.clickedRow]);

  const handleDescriptionChange = (item, e) => {
    if (e.target.value === "" || e.target.value === null) {
      return;
    }
    let updatedArray2 = [];
    let updatedArray3 = [];

    const array1 = state.emails;
    const array2 = state.tableDisplay;
    const array3 = state.filterTable;

    const objIndex1 = array1.findIndex((obj) => obj.SK === item.SK);
    const objIndex2 = array2.findIndex((obj) => obj.SK === item.SK);
    const objIndex3 = array3.findIndex((obj) => obj.SK === item.SK);

    if (e.target.value) {
      const update11 =
        [array1[objIndex1]]?.map((obj) => {
          if (obj.transactionstatus === undefined) {
            const { transactionstatus, ...rest } = obj;
            return rest;
          } else {
            return obj;
          }
        }) || [];

      if (objIndex2 !== -1) {
        const update12 =
          [array2[objIndex2]]?.map((obj) => {
            if (obj.transactionstatus === undefined) {
              const { transactionstatus, ...rest } = obj;
              return rest;
            } else {
              return obj;
            }
          }) || [];

        let update2 = { ...update12[0], description: e.target.value };
        let updatedArray2 = [
          ...array2.slice(0, objIndex2),
          update2,
          ...array2.slice(objIndex2 + 1),
        ];
      }

      if (objIndex3 !== -1) {
        const update13 =
          [array3[objIndex3]]?.map((obj) => {
            if (obj.transactionstatus === undefined) {
              const { transactionstatus, ...rest } = obj;
              return rest;
            } else {
              return obj;
            }
          }) || [];

        let update3 = { ...update13[0], description: e.target.value };

        let updatedArray3 = [
          ...array3.slice(0, objIndex3),
          update3,
          ...array3.slice(objIndex3 + 1),
        ];

        setState((prev) => ({
          ...prev,
          updatedArray: updatedArray3,
        }));
      }

      const update1 = { ...update11[0], description: e.target.value };
      const updatedArray1 = [
        ...array1.slice(0, objIndex1),
        update1,
        ...array1.slice(objIndex1 + 1),
      ];
      postRequest(`api/edureka/handleTagging`, {
        item: { ...update1, showtextarea: false },
      }).then((res) => {
        if (state.filterTable?.length) {
          setState((prev) => ({
            ...prev,
            emails: updatedArray1,
            resetData: updatedArray1,
            filterTable: prev.updatedArray,
          }));
        } else {
          setState((prev) => ({
            ...prev,
            emails: updatedArray1,
            resetData: updatedArray1,
          }));
        }
      });
    }
  };

  const handleDescriptionDelete = (item) => {
    const array1 = state.emails;
    const array2 = state.tableDisplay;
    const array3 = state.filterTable;

    const objIndex1 = array1.findIndex((obj) => obj.SK === item.SK);
    const objIndex2 = array2.findIndex((obj) => obj.SK === item.SK);
    const objIndex3 = array3.findIndex((obj) => obj.SK === item.SK);

    // Clear description
    if (objIndex1 !== -1) {
      array1[objIndex1].description = "";
    }

    if (objIndex2 !== -1) {
      array2[objIndex2].description = "";
    }

    if (objIndex3 !== -1) {
      array3[objIndex3].description = "";
    }

    setState((prev) => ({
      ...prev,
      emails: array1,
      tableDisplay: array2,
      filterTable: array3,
    }));

    postRequest(`api/edureka/handleTagging`, {
      item: { ...item, description: "", showtextarea: false },
    }).then((res) => {
      console.log(res);
    });

    item.showtextarea = false;
  };

  const handleReCompute = (item) => {
    const clickedRow = [...state.clickedRow, item.SK];
    setState((prev) => ({ ...prev, clickedRow }));
    console.log(item);

    postRequest(
      `api/edureka/handleReCompute`,
      {
        item: item,
        orgid: orgid,
        orgname: companyName,
      },
      2000000,
    )
      .then((res) => {
        let updated = state.clickedRow.filter(
          (row) => row != res.res.data.fe_sk,
        );
        setState((prev) => ({ ...prev, clickedRow: updated }));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        if (state.clickedRow.length === 0) handleSubmit(true);
      });
  };

  const customSort = (dateStrings) => {
    const order = {
      Processed: 0,
      "Duplicate Invoice": 1,
      "Not Processed": 2,
    };

    return dateStrings.sort((a, b) => {
      const statusComparison = order[a.Status] - order[b.Status];

      if (statusComparison !== 0) {
        return statusComparison;
      }

      return new Date(a.Date) - new Date(b.Date);
    });
  };

  const handleFieldChange = (fieldName, val) => {
    setState((prev) => ({
      ...prev,
      formData: {
        ...prev.formData,
        [fieldName]: val,
      },
    }));
  };

  useEffect(() => {
    setState((prev) => ({ ...prev, page: 0 }));
    handleFilter();
  }, [state.formData]);

  const handleFilter = () => {
    let Array = [];

    let from = [state.formData.From];
    let attachment = [state.formData.Attachment];
    let status = [state.formData.Status];
    let uploadmode = [state.formData.UploadMode];
    let vendorname = [state.formData.VendorName];
    let invoicenumber = [state.formData.InvoiceRef];
    let billnumber = [state.formData.BillNumber];
    let documentnumber = [state.formData.DocumentNumber];
    let tag = [state.formData.Tag];
    let documentstatus = [state.formData.transactionstatus];
    let integrationstatus = [state.formData.integrationStatus];
    let data = state.emails;
    console.log(data);

    if (!from?.[0]) {
      from = [...(state.dropdown_from || [])];
    }

    if (!attachment?.[0]) {
      attachment = [...(state.dropdown_attachment || [])];
    }

    if (!status?.[0]) {
      status = [...(state.dropdown_status || [])];
    }

    if (!uploadmode?.[0]) {
      uploadmode = [...(state.dropdown_UploadMode || [])];
    }

    if (!vendorname?.[0]) {
      vendorname = [...(state.dropdown_vendorname || [])];
      vendorname.push("", undefined);
    }

    if (!invoicenumber?.[0]) {
      invoicenumber = [...(state.dropdown_invoicenumber || [])];
      invoicenumber.push("", undefined);
    }

    if (!billnumber?.[0]) {
      billnumber = [...(state.dropdown_billnumber || [])];
      billnumber.push("", undefined);
    }

    if (!documentnumber?.[0]) {
      documentnumber = [...(state.dropdown_documentnumber || [])];
      documentnumber.push("", undefined);
    }

    if (!tag?.[0]) {
      tag = [...(state.dropdown_tag || [])];
      tag.push("", undefined);
    }

    if (!documentstatus?.[0]) {
      documentstatus = [...(state.dropdown_documentstatus || [])];
      documentstatus.push("", undefined);
    }

    if (!integrationstatus?.[0]) {
      integrationstatus = [...(state.dropdown_integrationStatus || [])];
      integrationstatus.push("Nil", "", undefined);
    }

    for (const [i, item] of data.entries()) {
      if (
        from.includes(item.From) &&
        attachment.includes(item.Attachment) &&
        status.includes(item.Status) &&
        uploadmode.includes(item.UploadMode) &&
        vendorname.includes(item.VendorName) &&
        invoicenumber.includes(item.InvoiceRef) &&
        billnumber.includes(item.BillNumber) &&
        documentnumber.includes(item.DocumentNumber) &&
        tag.includes(item.Tag) &&
        documentstatus.includes(item.transactionstatus) &&
        integrationstatus.includes(item.integrationStatus)
      ) {
        Array.push(item);
      }

      if (i === data?.length - 1) {
        setState((prev) => ({
          ...prev,
          filterTable: Array?.length ? Array : [],
        }));
      }
    }
  };

  const handleTagChange = (item, e) => {
    let updatedArray2 = [];
    let updatedArray3 = [];

    const array1 = state.emails;
    const array2 = state.tableDisplay;
    const array3 = state.filterTable;

    const objIndex1 = array1.findIndex((obj) => obj.SK === item.SK);
    const objIndex2 = array2.findIndex((obj) => obj.SK === item.SK);
    const objIndex3 = array3.findIndex((obj) => obj.SK === item.SK);

    if (e.target.value) {
      const update11 =
        [array1[objIndex1]]?.map((obj) => {
          if (obj.transactionstatus === undefined) {
            const { transactionstatus, ...rest } = obj;
            return rest;
          } else {
            return obj;
          }
        }) || [];

      if (objIndex2 !== -1) {
        const update12 =
          [array2[objIndex2]]?.map((obj) => {
            if (obj.transactionstatus === undefined) {
              const { transactionstatus, ...rest } = obj;
              return rest;
            } else {
              return obj;
            }
          }) || [];

        let update2 = { ...update12[0], Tag: e.target.value };

        let updatedArray2 = [
          ...array2.slice(0, objIndex2),
          update2,
          ...array2.slice(objIndex2 + 1),
        ];
      }

      if (objIndex3 !== -1) {
        const update13 =
          [array3[objIndex3]]?.map((obj) => {
            if (obj.transactionstatus === undefined) {
              const { transactionstatus, ...rest } = obj;
              return rest;
            } else {
              return obj;
            }
          }) || [];

        let update3 = { ...update13[0], Tag: e.target.value };

        let updatedArray3 = [
          ...array3.slice(0, objIndex3),
          update3,
          ...array3.slice(objIndex3 + 1),
        ];

        setState((prev) => ({
          ...prev,
          updatedArray: updatedArray3,
        }));
      }

      const update1 = { ...update11[0], Tag: e.target.value };

      const updatedArray1 = [
        ...array1.slice(0, objIndex1),
        update1,
        ...array1.slice(objIndex1 + 1),
      ];

      postRequest(`api/edureka/handleTagging`, {
        item: { ...update1, showtextarea: false },
      }).then((res) => {
        if (state.filterTable?.length) {
          setState((prev) => ({
            ...prev,
            emails: updatedArray1,
            resetData: updatedArray1,
            filterTable: prev.updatedArray,
          }));
        } else {
          setState((prev) => ({
            ...prev,
            emails: updatedArray1,
            resetData: updatedArray1,
          }));
        }
      });
    }
  };

  const handleReset = () => {
    setState((prev) => ({
      ...prev,
      currentPage: 1,
      emails: prev.resetData,
      filterTable: [],
      formData: {
        FromDate: "",
        ToDate: "",
        Date: "",
        From: "",
        Subject: "",
        Attachment: "",
        Status: "",
        VendorName: "",
        InvoiceRef: "",
        InvoiceDate: "",
        BillNumber: "",
        Tag: "",
        transactionstatus: "",
        DocumentNumber: "",
        UploadMode: "",
        integrationStatus: "",
      },
    }));
  };

  const handleDownload = () => {
    downloadLink.current.link.click();
  };

  const prepareDownloadData = () => {
    const data = !state.filterTable?.length ? state.emails : state.filterTable;
    const sanitizedData = [];
    for (const row of data) {
      const sanitizedRowData = {};
      for (const column in row) {
        sanitizedRowData[column] = globalhelper.sanitizeText(row[column]);
      }
      sanitizedData.push(sanitizedRowData);
    }
    return sanitizedData;
  };

  const onBack = () => {
    showSearchScreen(true);
    setState((prev) => ({
      ...prev,
      redirectBill: false,
      SearchJSON: [],
    }));
  };

  const handleBack = () => {
    window.location.reload();
  };

  const theme = useTheme();

  const getStepperInfo = (item) => {
    const steps = ["Processed", "Validated", "Activated", "Integrated"];
    let activeStep = 0;
    let errorStep = -1;
    let errorMessage = "";

    const statusStr = (item.Status || "").toString().trim().toLowerCase();

    if (statusStr.includes("validation_error") || statusStr.includes("validation error") || statusStr === "validation error") {
      activeStep = 1;
      errorStep = 1; // Step 2 Failed
      errorMessage = "Validation Error";
    } else if (statusStr.includes("activation_error") || statusStr.includes("activation error")) {
      activeStep = 2;
      errorStep = 2; // Step 3 Failed
      errorMessage = "Activation Error";
    } else if (statusStr.includes("integration_error") || statusStr.includes("integration error")) {
      activeStep = 3;
      errorStep = 3; // Step 4 Failed
      errorMessage = "Integration Error";
    } else if (statusStr === "completed" || statusStr.includes("completed")) {
      activeStep = 4; // All done
    } else if (statusStr === "integrated" || statusStr.includes("integrated")) {
      activeStep = 3; // Step 1+2+3 done, Step 4 running
    } else if (statusStr === "activated" || statusStr.includes("activated")) {
      activeStep = 2; // Step 1+2 done, Step 3 running
    } else if (statusStr === "validated" || statusStr.includes("validated")) {
      activeStep = 1; // Step 1 done, Step 2 running
    } else {
      activeStep = 0; // Step 1 is running, rest pending

      // Fallback: if there's a generic error not caught above, show it on the first step
      if (statusStr.includes("error") || statusStr.includes("fail") || statusStr.includes("reject")) {
        errorStep = 0;
        errorMessage = item.Status || "Error";
      }
    }

    return { steps, activeStep, errorStep, errorMessage };
  };

  const handleDrawerOpen = (item) => {
    setState((prev) => ({ ...prev, isDrawerOpen: true, drawerItem: item }));
  };

  const handleDrawerClose = () => {
    setState((prev) => ({ ...prev, isDrawerOpen: false, drawerItem: null }));
  };

  if (state.redirectBill) {
    return (
      <VR2_Forms
        selectedItem={state.selectedItem}
        company={orgid}
        companyName={companyName}
        screenName={"BillExtract"}
        screenAction={"edit"}
        From_SearchJSON={state.SearchJSON}
        onBack={onBack}
      />
    );
  }

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Filter Bills</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2} spacing={3}>
            <Grid item xs={1} sm={2} md={2.25}>
              <Autocomplete
                options={state.dropdown_from?.sort() || []}
                value={state.formData.From}
                onChange={(e, newValue) => handleFieldChange("From", newValue)}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="From"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={2.25}>
              <Autocomplete
                options={state.dropdown_attachment?.sort() || []}
                value={state.formData.Attachment}
                onChange={(e, newValue) =>
                  handleFieldChange("Attachment", newValue)
                }
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Attachment"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={2.25}>
              <Autocomplete
                options={state.dropdown_status?.sort() || []}
                value={state.formData.Status}
                onChange={(e, newValue) =>
                  handleFieldChange("Status", newValue)
                }
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={2.25}>
              <Autocomplete
                options={state.dropdown_vendorname?.sort() || []}
                value={state.formData.VendorName}
                onChange={(e, newValue) =>
                  handleFieldChange("VendorName", newValue)
                }
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Vendor Name"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={2.25}>
              <Autocomplete
                options={state.dropdown_invoicenumber?.sort() || []}
                value={state.formData.InvoiceRef}
                onChange={(e, newValue) =>
                  handleFieldChange("InvoiceRef", newValue)
                }
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Invoice Number"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={2.25}>
              <Autocomplete
                options={state.dropdown_billnumber?.sort() || []}
                value={state.formData.BillNumber}
                onChange={(e, newValue) =>
                  handleFieldChange("BillNumber", newValue)
                }
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Bill Number"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={2.25}>
              <Autocomplete
                options={state.dropdown_documentnumber?.sort() || []}
                value={state.formData.DocumentNumber}
                onChange={(e, newValue) =>
                  handleFieldChange("DocumentNumber", newValue)
                }
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Document No"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={2.25}>
              <Autocomplete
                options={state.dropdown_tag?.sort() || []}
                value={state.formData.Tag}
                onChange={(e, newValue) => handleFieldChange("Tag", newValue)}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tag"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={2.25}>
              <Autocomplete
                options={state.dropdown_documentstatus?.sort() || []}
                value={state.formData.transactionstatus}
                onChange={(e, newValue) =>
                  handleFieldChange("transactionstatus", newValue)
                }
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Document Status"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={2.25}>
              <Autocomplete
                options={state.dropdown_integrationStatus?.sort() || []}
                value={state.formData.integrationStatus}
                onChange={(e, newValue) =>
                  handleFieldChange("integrationStatus", newValue)
                }
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Integration Status"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      {state.show_pdf ? (
        <Dialog
          open={state.show_pdf}
          onClose={() =>
            setState((prev) => {
              if (prev.fileUrl) URL.revokeObjectURL(prev.fileUrl);
              return { ...prev, show_pdf: false };
            })
          }
          fullWidth
          maxWidth="lg"
        >
          <DialogContent sx={{ p: 2 }}>
            <Box sx={{ display: "flex", gap: 2, height: "500px" }}>
              {/* PDF Viewer */}
              <Box sx={{ flex: 3 }}>
                {state.fileUrl ? (
                  state.fileType.toLowerCase() === "pdf" ? (
                    <iframe
                      src={state.fileUrl}
                      title="pdf-viewer"
                      style={{ width: "100%", height: "100%", border: "none" }}
                      allowFullScreen
                    />
                  ) : (
                    <img
                      src={state.fileUrl}
                      alt="preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                )}
              </Box>

              {/* Description Area */}
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <TextField
                  multiline
                  rows={25}
                  value={state.pdfDescription}
                  onChange={handlePdfDescriptionChange}
                  placeholder="Enter Description"
                  fullWidth
                  sx={{
                    flexGrow: 1,
                    "& .MuiOutlinedInput-root": {
                      border: "2px solid black",
                    },
                  }}
                />

                <Button
                  size="small"
                  sx={{ m: 0.5 }}
                  variant="contained"
                  onClick={handlePdfDescriptionSave}
                  color="primary"
                >
                  Save Description
                </Button>
              </Box>
            </Box>

            {/* Optional Close Button in Top Right */}
            <IconButton
              aria-label="close"
              color="primary"
              onClick={() => setState((prev) => ({ ...prev, show_pdf: false }))}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogContent>
        </Dialog>
      ) : null}

      {state.sourceData?.length && state.sourceData?.length > 0 ? (
        <Box>
          <Box
            align="right"
            sx={{
              m: 2,
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              gap: 2,
            }}
          >
            {state.sourceData.length > 0 && (
              <>
                <Pagination
                  count={Math.ceil(
                    state.filterTable.length / state.rowsPerPage,
                  )}
                  page={state.page + 1}
                  onChange={(event, newPage) => {
                    handleChangePage(event, newPage - 1);
                  }}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
                &nbsp;
                <CSVLink
                  style={{ color: "white", textDecoration: "none" }}
                  data={state.sourceData}
                  filename="Inbox_reports.csv"
                >
                  <Button color="success" variant="contained">
                    <GetAppIcon />
                  </Button>
                </CSVLink>
              </>
            )}
          </Box>
          <TableContainer component={Paper} sx={{ overflowX: "hidden" }}>
            <Table sx={{ width: "100%", tableLayout: "fixed" }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {[
                    { label: "Date", align: "left", width: "12%" },
                    { label: "Attachment", align: "center", width: "10%" },
                    { label: "Status", align: "center", width: "11%" },
                    { label: "Vendor Name", align: "center", width: "12%" },
                    { label: "Invoice No", align: "center", width: "11%" },
                    { label: "Invoice Date", align: "center", width: "11%" },
                    { label: "Bill ID", align: "center", width: "11%" },
                    { label: "Document ID", align: "center", width: "11%" },
                    { label: "Action", align: "center", width: "10%" }
                  ].map((col, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        width: col.width,
                        whiteSpace: "nowrap",
                        pl: 1,
                        pt: 1.5,
                        pb: 1.5,
                        textAlign: col.align,
                        fontWeight: 900,
                        color: "#000000",
                        fontFamily: "'Inter', sans-serif",
                        fontSize: "0.95rem",
                        border: "1px solid #e2e8f0",
                        background: "#f8fafc",
                      }}
                    >
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {(state.filterTable.length > 0 &&
                  (state.rowsPerPage > 0
                    ? state.filterTable.slice(
                      state.page * state.rowsPerPage,
                      state.page * state.rowsPerPage + state.rowsPerPage,
                    )
                    : state.filterTable
                  ).map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell
                          sx={{ pl: 1, pt: 0, pb: 0, fontSize: "12px", width: "16%", border: "1px solid #e2e8f0", fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" }}
                        >
                          {formatDate(item.Date)}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            pl: 1,
                            pt: 0,
                            pb: 0,
                            textAlign: "center",
                            pt: 0,
                            pb: 0,
                            textAlign: "center",
                            width: "6%",
                            border: "1px solid #e2e8f0"
                          }}
                        >
                          <Tooltip title={item.Attachment}>
                            <Button
                              style={{ maxWidth: "100%", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}
                              variant="text"
                              size="small"
                              onClick={() => handleS3Download(item)}
                            >
                              <AttachFileIcon color="primary" />
                            </Button>
                          </Tooltip>
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            pl: 1,
                            pt: 0,
                            pb: 0,
                            textAlign: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "10%",
                            border: "1px solid #e2e8f0"
                          }}
                        >
                          {item.Status}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            pl: 1,
                            pt: 0,
                            pb: 0,
                            textAlign: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "15%",
                            border: "1px solid #e2e8f0"
                          }}
                        >
                          {item.VendorName}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            pl: 1,
                            pt: 0,
                            pb: 0,
                            textAlign: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "11%",
                            border: "1px solid #e2e8f0",
                            fontVariantNumeric: "tabular-nums"
                          }}
                        >
                          {item.InvoiceRef}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            pl: 1,
                            pt: 0,
                            pb: 0,
                            textAlign: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "11%",
                            border: "1px solid #e2e8f0",
                            fontVariantNumeric: "tabular-nums"
                          }}
                        >
                          {item.InvoiceDate || "-"}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            pl: 1,
                            pt: 0,
                            pb: 0,
                            textAlign: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "10%",
                            border: "1px solid #e2e8f0",
                            fontVariantNumeric: "tabular-nums"
                          }}
                        >
                          {item.BillNumber && <Button
                            variant="text"
                            size="small"
                            color="primary"
                            sx={{ p: 0, minWidth: 0, textDecoration: "underline", textTransform: "none", fontSize: "13px", fontWeight: 600 }}
                            disabled={
                              item.transactionstatus === "Active" ||
                              item.Tag === "Void" ||
                              item.Tag === "Excel File" ||
                              item.Tag === "CSV File" ||
                              item.Tag === "Duplicate Invoice" ||
                              item.Tag === "Sales Invoice" ||
                              item.Tag === "Incorrect Format" ||
                              item.Tag === "To Be Verified" ||
                              item.Tag === "Image File" ||
                              item.Tag === "Zip File" ||
                              item.transactionstatus === "Waiting For Approval"
                            }
                            onClick={() => handleBill(item)}
                          >
                            {item.BillNumber || "-"}
                          </Button> || "-"}
                        </TableCell>
                        {/* Doc No column moved after Bill ID */}
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            pl: 1,
                            pt: 0,
                            pb: 0,
                            textAlign: "center",
                            width: "11%",
                            border: "1px solid #e2e8f0"
                          }}
                        >{item.DocumentNumber &&
                          <Button
                            variant="text"
                            size="small"
                            color="primary"
                            sx={{ p: 0, textDecoration: "underline", minWidth: 0, textTransform: "none", fontSize: "13px", fontWeight: 600 }}
                            onClick={() => handleDocument(item)}
                          >
                            {item.DocumentNumber || "-"}
                          </Button> || "-"}
                        </TableCell>
                        {/* Doc No column moved after Bill ID */}
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            pl: 1,
                            pt: 0,
                            pb: 0,
                            textAlign: "center",
                            width: "10%",
                            border: "1px solid #e2e8f0"
                          }}
                        >

                          <Tooltip title="Reprocess">
                            <span>
                              <Button
                                variant="contained"
                                color="success"
                                size="small"
                                sx={{ ml: 1, minWidth: "36px", p: "6px" }}
                                onClick={() => handleReCompute(item)}
                                disabled={
                                  item.transactionstatus === "Active" ||
                                  item.transactionstatus ===
                                  "Waiting For Approval" ||
                                  item.transactionstatus === "Rejected" ||
                                  item.Tag === "Void" ||
                                  item.Tag === "Excel File" ||
                                  item.Tag === "CSV File" ||
                                  item.Tag === "Duplicate Invoice" ||
                                  item.Tag === "Sales Invoice" ||
                                  item.Tag === "Incorrect Format" ||
                                  item.Tag === "To Be Verified" ||
                                  item.Tag === "Image File" ||
                                  item.Tag === "Zip File" ||
                                  state.clickedRow.includes(item.SK) ||
                                  item.Status === "Reprocessing"
                                }
                              >
                                {(item.Status === "Reprocessing" ||
                                  state.clickedRow.includes(item.SK)) ? (
                                  <CircularProgress
                                    size={20}
                                    sx={{ color: "white" }}
                                  />
                                ) : (
                                  <SyncIcon fontSize="small" />
                                )}
                              </Button>
                            </span>
                          </Tooltip>
                          <Tooltip title="History">
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              sx={{ ml: 1, minWidth: "36px", p: "6px", display: "none" }}
                              onClick={() => getAuditLogs(item.DocumentNumber)}
                            >
                              <HistoryIcon fontSize="small" />
                            </Button>
                          </Tooltip>
                          <Tooltip title="More Actions">
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handleDrawerOpen(item)}
                              sx={{ ml: 1, minWidth: "36px", p: "6px", background: "#42a5f5", color: "#fff", "&:hover": { background: "#1e88e5" } }}
                            >
                              <MoreHorizIcon fontSize="small" />
                            </Button>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })) || (
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        sx={{ p: 5 }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <Alert severity="error" variant="outlined">
                            No matching records found. Please adjust your search
                            criteria.
                          </Alert>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : null}

      {/* More Details Drawer */}
      <Drawer
        anchor="right"
        open={state.isDrawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{ sx: { width: "750px", maxWidth: "92vw", overflow: "hidden" } }}
      >
        <Box sx={{ p: 2, height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5, flexShrink: 0 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#0f172a", fontSize: "16px" }}>
              Record Details
            </Typography>
            <IconButton onClick={handleDrawerClose} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 1.5, flexShrink: 0 }} />
          {state.drawerItem && (() => {
            const item = state.drawerItem;
            const stepperInfo = getStepperInfo(item);
            return (
              <Box sx={{ display: "flex", gap: 2, flex: 1, overflow: "hidden" }}>
                {/* Left Side - Grid of Paper cards */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: 1.5,
                    }}
                  >
                    {[
                      { label: "Subject", value: item.Subject, bg: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)", borderColor: "#ddd6fe", iconColor: "#8b5cf6" },
                      { label: "From", value: item.From, bg: "linear-gradient(135deg, #fefce8 0%, #fef9c3 100%)", borderColor: "#fef08a", iconColor: "#ca8a04" },
                      { label: "Document Status", value: item.transactionstatus, bg: "linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)", borderColor: "#fecdd3", iconColor: "#f43f5e" },
                      { label: "Integration Status", value: item.integrationStatus, bg: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", borderColor: "#e2e8f0", iconColor: "#64748b" },
                      { label: "ReasonForFail", value: item.ReasonForFailure, bg: "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)", borderColor: "#fed7aa", iconColor: "#f97316" },
                    ].map((field, idx) => (
                      <Paper
                        key={idx}
                        elevation={0}
                        sx={{
                          p: 1.5,
                          borderRadius: "12px",
                          background: field.bg,
                          border: `1px solid ${field.borderColor}`,
                          boxShadow: "0 2px 10px rgba(0,0,0,0.02)",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <Box sx={{ position: "absolute", top: 0, left: 0, width: "4px", height: "100%", backgroundColor: field.iconColor }} />
                        <Typography sx={{ fontSize: "10px", fontWeight: 800, color: field.iconColor, textTransform: "uppercase", mb: 0.5, letterSpacing: "0.5px" }}>
                          {field.label}
                        </Typography>
                        {field.isDocLink ? (
                          <Button
                            variant="text"
                            size="small"
                            sx={{ p: 0, minWidth: 0, textTransform: "none", fontSize: "13px", fontWeight: 600, color: "#0f172a", textAlign: "left" }}
                            disabled={item.transactionstatus === "Rejected"}
                            onClick={() => handleDocument(item)}
                          >
                            {field.value || "-"}
                          </Button>
                        ) : field.isBillLink ? (
                          <Button
                            variant="text"
                            size="small"
                            sx={{ p: 0, minWidth: 0, textTransform: "none", fontSize: "13px", fontWeight: 600, color: "#0f172a", textAlign: "left" }}
                            disabled={
                              item.transactionstatus === "Active" ||
                              item.Tag === "Void" ||
                              item.Tag === "Excel File" ||
                              item.Tag === "CSV File" ||
                              item.Tag === "Duplicate Invoice" ||
                              item.Tag === "Sales Invoice" ||
                              item.Tag === "Incorrect Format" ||
                              item.Tag === "To Be Verified" ||
                              item.Tag === "Image File" ||
                              item.Tag === "Zip File" ||
                              item.transactionstatus === "Waiting For Approval"
                            }
                            onClick={() => handleBill(item)}
                          >
                            {field.value || "-"}
                          </Button>
                        ) : (
                          <Typography sx={{ fontSize: "13px", color: "#0f172a", wordBreak: "break-word", lineHeight: 1.4, fontWeight: 500 }}>
                            {field.value || "-"}
                          </Typography>
                        )}
                      </Paper>
                    ))}

                    {/* Tag */}
                    <Paper elevation={0} sx={{ p: 1.5, borderRadius: "12px", background: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)", border: "1px solid #a7f3d0", position: "relative", overflow: "hidden" }}>
                      <Box sx={{ position: "absolute", top: 0, left: 0, width: "4px", height: "100%", backgroundColor: "#10b981" }} />
                      <Typography sx={{ fontSize: "10px", fontWeight: 800, color: "#10b981", textTransform: "uppercase", mb: 0.5, letterSpacing: "0.5px" }}>
                        Tag
                      </Typography>
                      <Select
                        size="small"
                        value={item.Tag ? item.Tag : ""}
                        fullWidth
                        onChange={(e) => handleTagChange(item, e)}
                        sx={{ fontSize: "13px", height: "32px", backgroundColor: "rgba(255,255,255,0.7)", "& .MuiOutlinedInput-notchedOutline": { borderColor: "transparent" }, "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#10b981" } }}
                      >
                        <MenuItem></MenuItem>
                        <MenuItem value="CSV File">CSV File</MenuItem>
                        <MenuItem value="Excel File">Excel File</MenuItem>
                        <MenuItem value="Valid">Valid</MenuItem>
                        <MenuItem value="Void">Void</MenuItem>
                        <MenuItem value="Duplicate Invoice">Duplicate Invoice</MenuItem>
                        <MenuItem value="Group Company Invoice">Group Company Invoice</MenuItem>
                        <MenuItem value="Clarify: Vendor/Item/CostAlloc">Clarify: Vendor/Item/CostAlloc</MenuItem>
                        <MenuItem value="Clarify: Vendor">Clarify: Vendor</MenuItem>
                        <MenuItem value="Clarify: Item/CostAlloc">Clarify: Item/CostAlloc</MenuItem>
                        <MenuItem value="Clarify: CostAlloc">Clarify: CostAlloc</MenuItem>
                        <MenuItem value="Clarify: MultiLingual">Clarify: MultiLingual</MenuItem>
                        <MenuItem value="Clarify: Vendor/CostAlloc">Clarify: Vendor/CostAlloc</MenuItem>
                        <MenuItem value="Clarify: tax">Clarify: tax</MenuItem>
                        <MenuItem value="Clarify: vendor/item/costAlloc/tax">Clarify: vendor/item/costAlloc/tax</MenuItem>
                        <MenuItem value="Clarify pan">Clarify pan</MenuItem>
                        <MenuItem value="Clarify: Item">Clarify: Item</MenuItem>
                        <MenuItem value="Clarify: splhandlinginvoices">Clarify: splhandlinginvoices</MenuItem>
                        <MenuItem value="Clarify: TDS">Clarify: TDS</MenuItem>
                        <MenuItem value="Clarify:Inventory">Clarify: Inventory</MenuItem>
                        <MenuItem value="Clarified: Vendor/Item/CostAlloc">Clarified: Vendor/Item/CostAlloc</MenuItem>
                        <MenuItem value="Clarified: Vendor">Clarified: Vendor</MenuItem>
                        <MenuItem value="Clarified: Item/CostAlloc">Clarified: Item/CostAlloc</MenuItem>
                        <MenuItem value="Clarified: CostAlloc">Clarified: CostAlloc</MenuItem>
                        <MenuItem value="Clarified: MultiLingual">Clarified: MultiLingual</MenuItem>
                        <MenuItem value="Clarified: Vendor/CostAlloc">Clarified: Vendor/CostAlloc</MenuItem>
                        <MenuItem value="Clarified: tax">Clarified: tax</MenuItem>
                        <MenuItem value="Clarified: vendor/item/costAlloc/tax">Clarified: vendor/item/costAlloc/tax</MenuItem>
                        <MenuItem value="Clarified pan">Clarified pan</MenuItem>
                        <MenuItem value="Clarified: Item">Clarified: Item</MenuItem>
                        <MenuItem value="Clarified: splhandlinginvoices">Clarified: splhandlinginvoices</MenuItem>
                        <MenuItem value="Clarified: TDS">Clarified: TDS</MenuItem>
                        <MenuItem value="Clarified: Inventory">Clarified: Inventory</MenuItem>
                        <MenuItem value="Sales Invoice">Sales Invoice</MenuItem>
                        <MenuItem value="Incorrect Format">Incorrect Format</MenuItem>
                        <MenuItem value="Incomplete VM">Incomplete VM</MenuItem>
                        <MenuItem value="InProgress">In Progress</MenuItem>
                        <MenuItem value="Reviewed">Reviewed</MenuItem>
                        <MenuItem value="Delivery Partners">Delivery Partners</MenuItem>
                        <MenuItem value="To Be Verified">To Be Verified</MenuItem>
                        <MenuItem value="Image File">Image File</MenuItem>
                        <MenuItem value="Zip File">Zip File</MenuItem>
                        <MenuItem value="Invalid">Invalid</MenuItem>
                      </Select>
                    </Paper>

                    {/* Additional Inputs */}
                    <Paper elevation={0} sx={{ p: 1.5, borderRadius: "12px", background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)", border: "1px solid #bfdbfe", position: "relative", overflow: "hidden", gridColumn: "1 / -1" }}>
                      <Box sx={{ position: "absolute", top: 0, left: 0, width: "4px", height: "100%", backgroundColor: "#3b82f6" }} />
                      <Typography sx={{ fontSize: "10px", fontWeight: 800, color: "#3b82f6", textTransform: "uppercase", mb: 0.5, letterSpacing: "0.5px" }}>
                        Additional Inputs (Description)
                      </Typography>
                      <TextField
                        key={`desc-${item.SK}-${item.description}`}
                        multiline
                        minRows={2}
                        maxRows={4}
                        defaultValue={item.description || ""}
                        onChange={(e) => { item._tempDesc = e.target.value; }}
                        placeholder="Enter Description here..."
                        fullWidth
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "rgba(255,255,255,0.7)",
                            fontSize: "13px",
                            "& fieldset": { borderColor: "transparent" },
                            "&:hover fieldset": { borderColor: "#3b82f6" },
                            "&.Mui-focused fieldset": { borderColor: "#2563eb" },
                          },
                        }}
                      />
                      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1.5 }}>
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            item._tempDesc = "";
                            handleDescriptionChange(item, { target: { value: "" } });
                            setState(prev => ({ ...prev, drawerItem: { ...item, description: "" } }));
                          }}
                          sx={{ textTransform: "none", fontWeight: 600, fontSize: "12px", py: 0.2 }}
                        >
                          Delete
                        </Button>
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            const val = item._tempDesc !== undefined ? item._tempDesc : (item.description || "");
                            handleDescriptionChange(item, { target: { value: val } });
                            setState(prev => ({ ...prev, drawerItem: { ...item, description: val } }));
                          }}
                          sx={{ background: "#3b82f6", "&:hover": { background: "#2563eb" }, textTransform: "none", fontWeight: 600, fontSize: "12px", py: 0.2 }}
                        >
                          Save
                        </Button>
                      </Box>
                    </Paper>
                  </Box>
                </Box>

                {/* Right Side - Vertical Stepper */}
                <Divider orientation="vertical" flexItem />
                <Box sx={{ width: "240px", flexShrink: 0, pt: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
                  <Typography sx={{ fontSize: "14px", fontWeight: 800, color: "#0f172a", mb: 1, textAlign: "left", px: 1 }}>
                    Processing Flow
                  </Typography>
                  {stepperInfo.steps.map((label, idx) => {
                    const isCompleted = idx < stepperInfo.activeStep && idx !== stepperInfo.errorStep;
                    const isCurrent = idx === stepperInfo.activeStep && idx !== stepperInfo.errorStep;
                    const isError = idx === stepperInfo.errorStep;
                    const isPending = idx > stepperInfo.activeStep;

                    let bgColor = "#f8fafc";
                    let borderColor = "#e2e8f0";
                    let iconBg = "#94a3b8";
                    let subtext = "Pending";
                    let textColor = "#64748b";

                    if (isCompleted) {
                      bgColor = "#ecfdf5";
                      borderColor = "#10b981";
                      iconBg = "#15803d";
                      subtext = "Completed";
                      textColor = "#15803d";
                    } else if (isCurrent) {
                      bgColor = "#eff6ff";
                      borderColor = "#3b82f6";
                      iconBg = "#1d4ed8";
                      subtext = "Current Stage";
                      textColor = "#1d4ed8";
                    } else if (isError) {
                      bgColor = "#fff1f2";
                      borderColor = "#f43f5e";
                      iconBg = "#be123c";
                      subtext = stepperInfo.errorMessage || "Failed";
                      textColor = "#be123c";
                    }

                    const icons = [
                      <SyncIcon fontSize="small" />,
                      <FactCheckIcon fontSize="small" />,
                      <VerifiedIcon fontSize="small" />,
                      <PublishedWithChangesIcon fontSize="small" />
                    ];

                    return (
                      <Box
                        key={label}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          p: 1.2,
                          borderRadius: "12px",
                          backgroundColor: bgColor,
                          border: `1px solid ${borderColor}`,
                          boxShadow: isCurrent ? "0 4px 12px rgba(59, 130, 246, 0.1)" : "none",
                          transition: "all 0.2s ease"
                        }}
                      >
                        <Box
                          sx={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            backgroundColor: iconBg,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            flexShrink: 0,
                            boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
                          }}
                        >
                          {icons[idx]}
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: "12.5px", fontWeight: 700, color: "#1e293b", lineHeight: 1.2 }}>
                            Step {idx + 1}: {label}
                          </Typography>
                          <Typography sx={{ fontSize: "10.5px", fontWeight: 600, color: textColor, opacity: 0.9 }}>
                            {subtext}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            );
          })()}
        </Box>
      </Drawer>

      <DialogBox
        open={state.auditLogModalOpen}
        setOpen={handleCloseAuditLog}
        title="Document Audit Logs"
      >
        <Box sx={{ p: 1 }}>
          {Object.keys(state.auditLogs || {}).length > 0 ? (
            Object.entries(state.auditLogs).map(([field, changes], index) => (
              <Box key={field} sx={{ mb: 4 }}>
                <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 'bold', mb: 1, borderBottom: '1px solid #eee', pb: 1 }}>
                  {field}
                </Typography>
                <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #eee' }}>
                  <Table size="small">
                    <TableHead sx={{ backgroundColor: '#f9f9f9' }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>Changed By</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Timestamp</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Old Value</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>New Value</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {changes.map((change, i) => (
                        <TableRow key={i}>
                          <TableCell>{change.changed_by}</TableCell>
                          <TableCell>{new Date(change.times_tamp).toLocaleString()}</TableCell>
                          <TableCell sx={{ color: 'error.main', textDecoration: 'line-through' }}>{change.old_value}</TableCell>
                          <TableCell sx={{ color: 'success.main', fontWeight: 'bold' }}>{change.new_value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ))
          ) : (
            <Typography variant="body1" color="textSecondary" align="center" sx={{ p: 3 }}>
              No audit logs available for this document.
            </Typography>
          )}
        </Box>
      </DialogBox>

      <br />
    </>
  );
};

export default FetchEmail;